import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { addOrUpdateHeatingPoint } from "../../../actions/summerPointsActions";
import { useEffect, useRef, useContext } from "react";
import { weatherCtx } from "../../../utils/hooks/mollierWeatherContext";
import { addOrUpdateHeatingPointWinter } from "../../../actions/winterPointsActions";
import { handleKeyPressOnlyNumbers } from "../../../utils/validationFunctions";
import { useTranslation } from "react-i18next";

function Heating(props) {
  const heatingPoint = useSelector(
    (state) => state.processPoint.summerPoints
  ).find((point) => point.process === "heating");
  const temperatureValue = heatingPoint?.temperatureDryBulb || "";
  const [newTemperature, setNewTemperature] = useState(temperatureValue);
  const { chartConfig } = useContext(weatherCtx);
  const isFirstRender = useRef(true);

  const lastPoint = useSelector((state) => state.processPoint.summerPoints);
  const {t} = useTranslation()

  const dispatch = useDispatch();
  /*test */
  const [localValue, setLocalValue] = useState(props.heatingTemperature);
  useEffect(() => {
    setLocalValue(props.heatingTemperature);
  }, [props.heatingTemperature]);

  // Effect to update the Redux store value whenever the localValue changes
  /* useEffect(() => {
    summerWeather
      ? dispatch(
          addOrUpdateHeatingPoint(
            localValue,
            chartConfig.altitude,
            props.processID
          )
        )
      : dispatch(
          addOrUpdateHeatingPointWinter(
            localValue,
            chartConfig.altitude,
            props.processID
          )
        );
  }, [dispatch, localValue]);*/

  const handleProcessChange = () => {
    summerWeather
      ? dispatch(
          addOrUpdateHeatingPoint(
            localValue,
            chartConfig.altitude,
            props.processID
          )
        )
      : dispatch(
          addOrUpdateHeatingPointWinter(
            localValue,
            chartConfig.altitude,
            props.processID
          )
        );
  };
  /*test*/

  const { summerWeather } = useContext(weatherCtx);

  const handleTemperatureChange = (event) => {
    const newTemperature = event.target.value;
    summerWeather
      ? dispatch(
          addOrUpdateHeatingPoint(event.target.value, chartConfig.altitude)
        )
      : dispatch(
          addOrUpdateHeatingPointWinter(
            event.target.value,
            chartConfig.altitude
          )
        );
    setNewTemperature(newTemperature);
    //dispatch(updateTemperature(newTemperature));
  };

  /*useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip the first render
    }
    summerWeather
      ? dispatch(addOrUpdateHeatingPoint(newTemperature, chartConfig.altitude))
      : dispatch(
          addOrUpdateHeatingPointWinter(newTemperature, chartConfig.altitude)
        );
  }, [newTemperature, dispatch, summerWeather, chartConfig.altitude]);*/

  const handleBlur = () => {
    summerWeather
      ? dispatch(addOrUpdateHeatingPoint(newTemperature, chartConfig.altitude))
      : dispatch(
          addOrUpdateHeatingPointWinter(newTemperature, chartConfig.altitude)
        );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={1}
        alignItems="start"
        justifyContent="start"
        direction="row"
      >
        <Grid item xs={5}>
          <TextField
            label={t("mollier.heatingTemp")}
            id="outlined-start-adornment"
            name="newTemperature"
            //  value={props.heatingTemperature}
            value={localValue}
            defaultValue={temperatureValue}
            InputProps={{
              endAdornment: <InputAdornment position="end">°C</InputAdornment>,
            }}
            //onChange={handleTemperatureChange}
            onChange={(e) => {
              setLocalValue(e.target.value);
            }}
            inputProps={{ maxLength: 5 }}
            // onBlur={handleBlur}
            onBlur={handleProcessChange}
            // onChange={(e) => setNewTemperature(e.target.value)}
            onKeyPress={handleKeyPressOnlyNumbers}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Heating;
